// extracted by mini-css-extract-plugin
module.exports = {"loader__component":"loader_loader__component__16Qoi","rotate":"loader_rotate__2eDyi","ball1":"loader_ball1__3hZ1V","ball2":"loader_ball2__2BL82","loader":"loader_loader__2d6FG"};